import script from "./transportPayReview.vue?vue&type=script&setup=true&lang=js"
export * from "./transportPayReview.vue?vue&type=script&setup=true&lang=js"

import "./transportPayReview.vue?vue&type=style&index=0&id=ab5104d4&lang=less"

const __exports__ = script;

export default __exports__